module.exports = __webpack_public_path__ + "@/assets/img/image.82852970.svg";